import { render, staticRenderFns } from "./PrintCertificatesModal.vue?vue&type=template&id=17f06878&scoped=true"
import script from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
export * from "./PrintCertificatesModal.vue?vue&type=script&lang=js"
import style0 from "./PrintCertificatesModal.vue?vue&type=style&index=0&id=17f06878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f06878",
  null
  
)

export default component.exports